import style from "../CampaignDetails/Campaign.module.css";
import React, { useState, useEffect } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EventIcon from "@mui/icons-material/Event";
import { FixedSizeList as List } from "react-window";

const Notifications = ({ notificationData = [] }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    setNotifications(notificationData);
  }, [notificationData]);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear().toString().slice(-2);

    return `${day} ${month} ${year}`;
  };

  const handleUndo = (id) => {
    setNotifications((prev) => prev.filter((item) => item.id !== id));
  };

  const Row = ({ index, style, data }) => {
    const { notifications, formatDate, handleUndo } = data;
    const item = notifications[index];

    return (
      <div style={style} className="px-2">
        <div className="p-3 bg-gray-100 rounded-lg flex items-start">
          {item.type === "notification" ? (
            <NotificationsIcon className="w-6 h-6 text-gray-600 mr-3" />
          ) : (
            <EventIcon className="w-6 h-6 text-gray-600 mr-3" />
          )}

          <div className="flex-1">
            <div className="flex justify-between gap-2">
              <h3 className="text-sm font-semibold break-words">
                {item?.title}
              </h3>

              {item.createdAt && (
                <span className="text-xs text-gray-400 whitespace-nowrap">
                  {formatDate(item.createdAt)}
                </span>
              )}
            </div>

            <p className="text-sm text-gray-600">{item?.body || item?.date}</p>
          </div>

          {item.type === "schedule" && (
            <button
              onClick={() => handleUndo(item.id)}
              className="ml-3 text-sm text-blue-600 bg-white border px-2 py-1 rounded-lg shadow-sm"
            >
              Undo
            </button>
          )}
        </div>
      </div>
    );
  };

  const styles = {
    container: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "16px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      width: "100%",
      height: "100%",
    },
    listContainer: {
      height: "315px",
      overflow: "hidden",
    },
  };

  return (
    <div style={styles.container} className="shadow-lg">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Updates</h2>
      </div>

      <div
        style={styles.listContainer}
        className={`mt-2 rounded-lg ${style["custom-scrollbar"]}`}
      >
        {notifications.length > 0 ? (
          <List
            height={315}
            itemCount={notifications.length}
            itemSize={90}
            width="100%"
            itemData={{
              notifications,
              formatDate,
              handleUndo,
            }}
          >
            {Row}
          </List>
        ) : (
          <p className="text-sm text-gray-600">There is no Update</p>
        )}
      </div>
    </div>
  );
};

export default Notifications;
